/*
  go_to_top
*/
/**
 * Desktop/Mobile go to top button
 */

 /************************************************
 		MANAGE GO TO TOP BUTTON DISPLAY
 *************************************************/
$( window ).scroll(function() {
  var scrolltop_value = $(document).scrollTop();

  //-- show button when user has scrolled at least more than 101px
  if (scrolltop_value > 1000) {
    $(".go_to_top").show();
  }
  else {
    $(".go_to_top").hide();
  }
});

/************************************************
   MANAGE GO TO TOP BUTTON EVENT
*************************************************/
$(document.body).on("click", ".go_to_top, a[href='#top']", function(e) {
  e.preventDefault();
  //-- scroll to top animation
  $('html,body').stop().animate({ scrollTop: 0 }, 'slow');

});
